import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { setReadFullPolicyModelFalse } from "../../store/slices/modalSlice";
import { useNavigate } from "react-router-dom";

const ReadFullPolicyModel = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const openReadFullPolicy = useSelector(
    (state: { modal: { readFullPolicyModel: boolean } }) =>
      state.modal.readFullPolicyModel
  );

  const handleCloseReadFullPolicy = () => {
    dispatch(setReadFullPolicyModelFalse());
  };

  return (
    <>
      <Modal
        show={openReadFullPolicy}
        onHide={handleCloseReadFullPolicy}
        scrollable
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Amer Services</Modal.Title> */}
        </Modal.Header>
        <Modal.Body className="modal-dialog-scrollable ">
          <h4 className="modal-title border-bottom mb-2 pb-2">
            Cancellation policy
          </h4>

          <div>
            <p className="mb-1 font-12 ff-medium">
              Customers may cancel their request only during the review of their
              request with Good Hand, while showing status as “Under Review”.
              The cancellation request will not be entertained once the request
              is processed for submission (accepted by Good Hand).
            </p>
            <p className="mb-1 font-12 ff-medium">
              Furthermore, if Good Hand processes the Customer’s request and
              submits it to the Respective Government Department, the
              Department/Authorities may accept, approve or reject the request
              besides may ask for more documents or clarifications. In all these
              cases, the Customer will have no right to ask for cancellation of
              request or refund of any amount.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="p-0 border-0 rounded-0">
          <div className="d-flex align-items-center justify-content-between w-100 px-3 py-2">
            <button
              className="btn btn-primary w-100 font-14 ff-semibold py-3  bt--cart"
              onClick={() => {
                handleCloseReadFullPolicy();
                navigate("/CancellationPolicy");
              }}
            >
              Read Full Policy
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ReadFullPolicyModel;
